import { setBooleanResolver, resolveBooleanFlag } from './resolvers';

/**
 * Sets the flag resolver for boolean flags.
 * @param flagResolver
 */
export function setBooleanFeatureFlagResolver(flagResolver) {
  setBooleanResolver(flagResolver);
}

/**
 * Returns the value of a feature flag. If the flag does not resolve, it returns the "false" as a default value.
 * @param name
 */
export function getBooleanFF(name) {
  return resolveBooleanFlag(name);
}